import { urlImpactOf, urlImpactValue } from './urlImpact';

type UrlImpactValueProps = {
  affectedUrlCount: number;
  crawledUrlCount: number;
};

function UrlImpactValue({ affectedUrlCount, crawledUrlCount }: UrlImpactValueProps) {
  const impact = urlImpactOf(affectedUrlCount, crawledUrlCount);

  return (
    <>
      <div className="diagnostics-domain-figure">{urlImpactValue(impact)}</div>
      {impact.share !== null && <div className="diagnostics-evidence-note">{impact.share}</div>}
    </>
  );
}

export default UrlImpactValue;
